import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/sections/Footer";
import Consultation from "@/components/sections/Consultation";
import SEOHead from "@/components/SEOHead";
import { Link } from "@/lib/router-compat";
import Breadcrumbs from "@/components/Breadcrumbs";
import { buildBreadcrumbList, Crumb } from "@/components/schemaConstants";

const crumbs: Crumb[] = [
  { name: "Services Directory", href: "/services-directory" },
];
export const Elementor7428Page = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title={"Services Directory | Neuro Wellness TMS Centers of America"}
        description={
          "Explore all specialized psychiatric services, TMS protocols, ketamine infusions, psychotherapy, and patient resources at Neuro Wellness TMS Centers of America."
        }
        canonical={"/services-directory"}
        noIndex
        keywords={
          "Neuro Wellness services directory, psychiatric treatments Coral Springs, TMS ketamine psychotherapy Florida"
        }
      />

      <Navbar />
      <main className="pt-16 sm:pt-20">
        <div className="bg-background py-3">
          <div className="container-px mx-auto max-w-6xl px-4">
            <Breadcrumbs crumbs={crumbs} />
          </div>
        </div>
        <section className="relative bg-gradient-navy text-primary-foreground py-16 sm:py-24 overflow-hidden">
          <div className="container-px relative mx-auto max-w-5xl text-center space-y-4">
            <span className="inline-block rounded-md bg-accent px-6 py-2 text-sm sm:text-base font-bold text-white shadow-md uppercase tracking-wider">
              Service Directory
            </span>
            <h1 className="font-headings text-3xl sm:text-5xl font-extrabold text-white">
              Comprehensive Service Overview
            </h1>
            <p className="text-base sm:text-lg text-primary-foreground/80 max-w-3xl mx-auto">
              Neuro Wellness TMS Centers of America offers South Florida most
              advanced array of evidence-based psychiatric therapies and
              neuromodulation treatments.
            </p>
          </div>
        </section>

        <section className="py-12 sm:py-16 bg-background">
          <div className="container-px mx-auto max-w-5xl space-y-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <Link
                to="/services/tms"
                className="p-6 rounded-2xl border border-border bg-card shadow-soft hover:shadow-premium transition-all space-y-2 group"
              >
                <h3 className="font-bold text-primary text-xl group-hover:text-accent">
                  Transcranial Magnetic Stimulation (TMS)
                </h3>
                <p className="text-xs text-muted-foreground">
                  Apollo TMS system for depression, anxiety, OCD, and PTSD.
                </p>
              </Link>

              <Link
                to="/saint"
                className="p-6 rounded-2xl border border-border bg-card shadow-soft hover:shadow-premium transition-all space-y-2 group"
              >
                <h3 className="font-bold text-primary text-xl group-hover:text-accent">
                  SAINT Accelerated TMS
                </h3>
                <p className="text-xs text-muted-foreground">
                  5-day Stanford Accelerated protocol for rapid depression
                  relief.
                </p>
              </Link>

              <Link
                to="/services/spravato"
                className="p-6 rounded-2xl border border-border bg-card shadow-soft hover:shadow-premium transition-all space-y-2 group"
              >
                <h3 className="font-bold text-primary text-xl group-hover:text-accent">
                  SPRAVATO (Esketamine)
                </h3>
                <p className="text-xs text-muted-foreground">
                  FDA-approved REMS certified nasal spray for
                  treatment-resistant depression.
                </p>
              </Link>

              <Link
                to="/ketamine-treatment-coral-springs-fl"
                className="p-6 rounded-2xl border border-border bg-card shadow-soft hover:shadow-premium transition-all space-y-2 group"
              >
                <h3 className="font-bold text-primary text-xl group-hover:text-accent">
                  IV Ketamine Infusions
                </h3>
                <p className="text-xs text-muted-foreground">
                  Rapid-acting infusions for depression, severe anxiety, PTSD,
                  and chronic pain.
                </p>
              </Link>
            </div>
          </div>
        </section>

        <Consultation />
      </main>
      <Footer />
    </div>
  );
};
export default Elementor7428Page;
